import _get from "lodash/get";
import _isNil from "lodash/isNil";
/* eslint-disable no-nested-ternary */
import './index.css';
import { CollapsedSidebar, InstructionPane, InstructionsPlaceholder } from '@datacamp/exercise-instruction-pane';
import { HTMLContent } from '@datacamp/le-shared-components';
import ResizableElements, { CollapseContext } from '@datacamp/waffles-resizable-elements';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { sentry } from '../../lib/sentry';
import InteractivePane from '../InteractivePane';
import StyledInstructionsBody from '../styled/StyledInstructionsBody';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Exercise = _ref => {
  let {
    checkExercise,
    environment,
    exercise,
    exerciseId,
    onExerciseFinished,
    onExerciseStatusUpdate,
    showExercise,
    showSolution,
    updateLostXp,
    user
  } = _ref;
  const {
    t
  } = useTranslation('glossary');
  const [currentId, setCurrentId] = React.useState(undefined);
  const [newOutputs, setNewOutputs] = React.useState([]);
  if (currentId !== exerciseId) {
    setCurrentId(exerciseId);
    setNewOutputs([]);
  }
  const [disableActionButtons, setDisableActionButtons] = React.useState(false);
  const onToggleCompletionPane = React.useCallback(_ref2 => {
    let {
      completionPaneVisible
    } = _ref2;
    return setDisableActionButtons(completionPaneVisible);
  }, []);
  React.useEffect(() => {
    showExercise();
  }, [exerciseId, showExercise]);
  const onContinue = () => !_isNil(exercise) && onExerciseFinished({
    id: exerciseId
  });
  const checkExerciseCb = React.useCallback((message, success, groupedItems) => {
    setNewOutputs([{
      correct: success,
      message
    }]);
    checkExercise(message, success, groupedItems);
  }, [checkExercise]);
  const onError = React.useCallback((error, extra) => {
    sentry.captureError(error, extra);
  }, []);
  return ___EmotionJSX("div", {
    className: "drag-and-drop-exercise"
  }, ___EmotionJSX(ResizableElements, {
    collapsedSize: 38,
    initialProportions: [30, 70],
    orientation: "row"
  }, ___EmotionJSX(CollapseContext.Consumer, null, _ref3 => {
    var _exercise$instruction;
    let {
      collapsedFirstElement,
      toggleFirstElement
    } = _ref3;
    return collapsedFirstElement ? ___EmotionJSX(CollapsedSidebar, {
      className: "dc-panel exercise__sidebar",
      onClick: toggleFirstElement
    }) : exercise === undefined ? ___EmotionJSX(InstructionsPlaceholder, {
      subHeadingText: "Exercise"
    }) : ___EmotionJSX(InstructionPane, {
      assignment: exercise.assignment,
      environment: environment,
      exerciseId: exerciseId,
      exerciseSubtitle: t('exercise', {
        count: 1
      }),
      hint: exercise.hint,
      instructionSubtitle: t('instruction', {
        count: 2
      }),
      isLoggedIn: _get(user, 'isLoggedIn', false),
      isRatingPermitted: exercise.isRatingPermitted,
      maxTimesToShowSolution: Infinity,
      newOutputs: newOutputs,
      onClickCollapse: toggleFirstElement,
      onContinue: onContinue,
      onError: onError,
      onTakeHint: undefined,
      onTakeSolution: showSolution,
      onToggleCompletionPane: onToggleCompletionPane,
      onUpdateXp: updateLostXp,
      padBottom: true,
      solutionMessage: undefined,
      title: exercise.title,
      xp: exercise.xp
    }, ___EmotionJSX(StyledInstructionsBody, null, ___EmotionJSX(HTMLContent, {
      html: (_exercise$instruction = exercise.instructions) !== null && _exercise$instruction !== void 0 ? _exercise$instruction : '',
      mathJaxEnabled: true
    })));
  }), ___EmotionJSX(InteractivePane, {
    checkExercise: checkExerciseCb,
    disableActionButtons: disableActionButtons,
    environment: environment,
    exercise: exercise,
    exerciseId: exerciseId,
    onExerciseStatusUpdate: onExerciseStatusUpdate,
    user: user
  })));
};